module.exports = __webpack_public_path__ + "static/assets/d0705bad64076830636cdca02585a718.png";